var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import { useWeb3Context } from "shared/lib/hooks/web3Context";
import AirdropInfo from "./AirdropInfo";
import RBNClaimModalContent from "shared/lib/components/Common/RBNClaimModalContent";
import useMerkleDistributor from "../../hooks/useMerkleDistributor";
import useAirdrop from "../../hooks/useAirdrop";
import { usePendingTransactions } from "shared/lib/hooks/pendingTransactionsContext";
import BasicModal from "shared/lib/components/Common/BasicModal";
var AirdropModal = function (_a) {
    var show = _a.show, onClose = _a.onClose;
    var _b = useState("info"), step = _b[0], setStep = _b[1];
    var merkleDistributor = useMerkleDistributor();
    var account = useWeb3Wallet().account;
    var provider = useWeb3Context().provider;
    var airdrop = useAirdrop();
    var addPendingTransaction = usePendingTransactions().addPendingTransaction;
    var claimAirdrop = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var tx, txhash, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!airdrop || !merkleDistributor || !account) {
                        return [2 /*return*/];
                    }
                    setStep("claim");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, merkleDistributor.claim(airdrop.proof.index, account, airdrop.proof.amount, airdrop.proof.proof)];
                case 2:
                    tx = _a.sent();
                    setStep("claiming");
                    txhash = tx.hash;
                    addPendingTransaction({
                        txhash: txhash,
                        type: "claim",
                        amount: airdrop.total.toLocaleString(),
                    });
                    return [4 /*yield*/, provider.waitForTransaction(txhash, 2)];
                case 3:
                    _a.sent();
                    setStep("claimed");
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    setStep("info");
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        account,
        addPendingTransaction,
        airdrop,
        merkleDistributor,
        setStep,
        provider,
    ]);
    var handleClose = useCallback(function () {
        onClose();
        if (step === "claim" || step === "claimed") {
            setStep("info");
        }
    }, [onClose, step]);
    return (_jsx(BasicModal, __assign({ show: show, onClose: handleClose, height: 580, animationProps: {
            key: step,
            transition: {
                duration: 0.25,
                type: "keyframes",
                ease: "easeInOut",
            },
            initial: step === "info" || step === "claim"
                ? {
                    x: 50,
                    opacity: 0,
                }
                : {},
            animate: step === "info" || step === "claim"
                ? {
                    x: 0,
                    opacity: 1,
                }
                : {},
            exit: step === "info"
                ? {
                    x: -50,
                    opacity: 0,
                }
                : {},
        } }, { children: step === "info" ? (_jsx(AirdropInfo, { onClaim: claimAirdrop }, void 0)) : (_jsx(RBNClaimModalContent, { step: step, type: "rbn" }, void 0)) }), void 0));
};
export default AirdropModal;
//# sourceMappingURL=AirdropModal.js.map